

































/* General */
import Vue from 'vue'

/* Mixins */

/* Components */

/* Helpers */

import RouteAssistant from '@/helpers/route-assistant'

/* Data types */
import { EEntities } from '@/types'
import { ILinkedItemForListing } from '@/api/types/response.types'

/* API */

export default Vue.extend({
  name: 'RelatedItemsList',

  props: {
    items: {
      type: Array as () => ILinkedItemForListing[],
      default: (): ILinkedItemForListing[] => [],
    },
    entityType: {
      type: String as () => EEntities,
      default: EEntities.MAILBOXES,
    },
    groupByEntity: {
      type: Boolean,
      default: false,
    },
    addLinkText: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      showAllItems: false,
      showModal: false,
    }
  },

  computed: {
    itemsToDisplay(): ILinkedItemForListing[] {
      return this.sortByEntityAndActive(this.items)
    },
    canManageItems(): boolean {
      return this.addLinkText.length > 0
    },
  },

  methods: {
    iconClass(item: ILinkedItemForListing): string {
      let result = ''

      if (this.entityType === EEntities.MAILBOXES) {
        result = 'ddi-conversation'
      } else {
        result = 'ddi-task'
      }

      if (!item.entityAccessible) {
        result += '-locked'
      }

      return result
    },
    openItemDetailInNewWindow(item: ILinkedItemForListing) {
      if (this.entityType === EEntities.MAILBOXES) {
        RouteAssistant.goToConversation(
          this.$router,
          this.$route.params.accountId,
          item.entity.id,
          item.id,
          item.entity.name,
          item.refNumber,
          item.title,
          true,
        )
      } else {
        RouteAssistant.goToTask(
          this.$router,
          this.$route.params.accountId,
          item.entity.id,
          item.id,
          this.$permissions,
          item.entity.name,
          item.refNumber,
          item.title,
          true,
        )
      }
    },
    // Show entity name if the indexed item has a different entity than its predecessor
    showEntityName(index: number): boolean {
      if (!this.groupByEntity) {
        return false
      }

      if (index === 0) {
        return true
      }

      if (this.items[index - 1].entity.id !== this.items[index].entity.id) {
        return true
      }
    },

    sortByEntityAndActive(items: ILinkedItemForListing[]) {
      items.sort((a: ILinkedItemForListing, b: ILinkedItemForListing) => {
        if (a.entity.name.toLowerCase() < b.entity.name.toLowerCase()) {
          return -1
        }
        if (a.entity.name.toLowerCase() > b.entity.name.toLowerCase()) {
          return 1
        }
        if (a.isActive && !b.isActive) {
          return -1
        }
        if (!a.isActive && b.isActive) {
          return 1
        }
        return 0
      })
      return items
    },
  },
})
